import { defineMessages } from 'react-intl';

export const shipmentDetailsSectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Shipment Details',
    id: '0HszZD',
    description: 'Title of the shipment details card in the freight details view',
  },
  shipFromTitle: {
    defaultMessage: 'Ship From Location',
    id: '54B8PD',
    description: 'Column heading for the origin address of a freight shipment',
  },
  shipToTitle: {
    defaultMessage: 'Ship To Location',
    id: 'FRLwuq',
    description: 'Column heading for the destination address of a freight shipment',
  },
  emptyAddress: {
    defaultMessage: 'No address available',
    id: 'C6nuv1',
    description: 'Empty state shown when a freight shipment address is missing',
  },
  pickupServicesTitle: {
    defaultMessage: 'Pickup Services',
    id: 'ITJ7Ie',
    description: 'Heading for the pickup accessorial service tags',
  },
  deliveryServicesTitle: {
    defaultMessage: 'Delivery Services',
    id: '7nklCJ',
    description: 'Heading for the delivery accessorial service tags',
  },
});
